module.exports = __webpack_public_path__ + "static/media/handshake.69028e39.svg";